"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTableCellOverrides = function (_a) {
    var _b;
    var palette = _a.palette, spacing = _a.spacing, typography = _a.typography, breakpoints = _a.breakpoints, shape = _a.shape;
    return ({
        root: {
            padding: spacing(5, 2),
            borderBottom: undefined,
            "&:not($paddingNone):not($paddingCheckbox):first-child": {
                paddingLeft: spacing(4),
            },
            "&:not($paddingNone):not($paddingCheckbox):last-child": {
                paddingRight: spacing(4),
            },
        },
        head: (_b = {
                fontSize: typography.pxToRem(12),
                fontWeight: undefined,
                lineHeight: 1.25,
                color: palette.text.secondary
            },
            _b[breakpoints.up("lg")] = {
                lineHeight: 1.5,
            },
            _b[breakpoints.up("xl")] = {
                fontSize: typography.pxToRem(14),
                lineHeight: 1.43,
            },
            _b["&:first-child:not($paddingCheckbox)"] = { paddingLeft: 0 },
            _b),
        body: {
            borderBottom: "1px solid " + palette.background.paper,
            // Radius only seems to work on table by applying both on tbody and cell
            ".MuiTableRow-root:first-child &": {
                "&:first-child": { borderTopLeftRadius: shape.borderRadius },
                "&:last-child": { borderTopRightRadius: shape.borderRadius },
            },
            ".MuiTableRow-root:last-child &": {
                borderBottom: "none",
                "&:first-child": { borderBottomLeftRadius: shape.borderRadius },
                "&:last-child": { borderBottomRightRadius: shape.borderRadius },
            },
        },
        paddingCheckbox: {
            padding: spacing(0, 0, 0, 2),
            width: spacing(10),
            "&:last-child": {
                paddingRight: spacing(4),
                width: spacing(12),
            },
        },
        sizeSmall: {
            padding: undefined,
            paddingTop: spacing(3),
            paddingBottom: spacing(3),
            "&:last-child": {
                paddingRight: undefined,
            },
            "&$head": {
                paddingTop: spacing(4),
                paddingBottom: spacing(4),
            },
            "&$paddingCheckbox": {
                padding: spacing(0, 2, 0, 4),
                "&:last-child": {
                    paddingLeft: spacing(2),
                    paddingRight: spacing(4),
                },
            },
        },
    });
};
//# sourceMappingURL=MuiTableCell.js.map